import { useEffect } from "react";
import { SectionSkeleton } from "@/components/profile-cards";
import { useCompanyDetails } from "@/hooks/useCompanyDetails";
import { useFetchLoanProcessorProfile } from "@/pages/Onboarding/LoanProcessor/hooks/useFetchLoanProcessorProfile";
import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";
import { CompanyDetails } from "../components/CompanyDetails";

const LoanProcessorDetailsSections = () => {
  const { profile } = useFetchLoanProcessorProfile();
  const {
    data: companyDetails,
    loading: companyLoading,
    getCompanyDetails,
  } = useCompanyDetails();

  useEffect(() => {
    if (!profile?.lenderId) return;

    getCompanyDetails({
      id: profile.lenderId,
      companyType: "lender",
    });
  }, [getCompanyDetails, profile]);

  if (!profile || companyLoading) {
    return <SectionSkeleton />;
  }

  return <CompanyDetails company={companyDetails} companyType="lender" />;
};

const LoanProcessorDetails = () => {
  const user = useAppStore((s) => s.user);

  if (user?.role !== UserRole.LoanProcessor) return null;

  return <LoanProcessorDetailsSections />;
};

export default LoanProcessorDetails;
